export default "__VITE_ASSET__Dw3A$_cN__"